<template>
  <div>
    <div v-if="isLoading" class="text-center ma-12">
      <v-progress-circular
        size="48"
        width="4"
        indeterminate
        color="grey lighten-2"
      ></v-progress-circular>
    </div>

    <v-data-table
      v-else-if="!isLoading"
      :headers="headers"
      :items="list"
      sort-by="name"
      :search="search"
      class="general-table"
      @click:row="onItemClick"
      :loading="isLoading"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.articleNo="{ header }">
        <lang t="BUNDLE_GROUPS-DETAIL-TBL-HEADER-ARTICLENO"></lang>
      </template>

      <template v-slot:header.name="{ header }">
        <lang t="BUNDLE_GROUPS-DETAIL-TBL-HEADER-NAME"></lang>
      </template>

      <template v-slot:header.gtin="{ header }">
        <lang t="BUNDLE_GROUPS-DETAIL-TBL-HEADER-GTIN"></lang>
      </template>

      <template v-slot:top> </template>

      <template v-slot:item.name="{ articleNo }">
        {{ item.articleNo }}
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:item.gtin="{ item }">
        {{ item.gtin }}
      </template>

      <template v-slot:footer.page-text="props" v-if="(list.length > 0)">
        <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
        <display-number :number="list.length" />
      </template>


      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="pa-1"
          color="grey darken-2"
          @click.stop.prevent="itemDelete(item)"
          :disabled="item.bundleCount == 0"
          >mdi-delete</v-icon
        >
      </template>

      <template v-slot:no-data>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSaving: false,
      isLoading: true,
      item: {
        name: null,
        bundles: null,
      },
      headers: [
        {
          text: "ArticleNo",
          align: "start",
          value: "articleNo",
          sortable: true,
          class: 'general-table__th--3'
        },
        { text: "Name", align: "start", value: "name", sortable: true, class: 'general-table__th--3' },
        { text: "GTIN", align: "start", value: "gtin", sortable: true, class: 'general-table__th--3' },
        { text: "", align: "end", value: "actions", width: '80px' },
      ],
    };
  },

  created() {
    this.initialize();
  },

  watch: {},
  computed: {
    list(){
      return this.item.bundles.filter((b) => b.bundlegroup_id != null)
    }
  },
  methods: {
    itemDelete(item) {
      this.$confirm(
        this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }),
        {
          title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
          buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
          buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
        }
      ).then((res) => {
        if (res) {
          let index = this.item.bundles.findIndex((i) => i.id == item.id);
          if (index > -1) {
            this.$set(this.item.bundles[index], "bundlegroup_id", null);
            this.save();
          }
        }
      });
    },

    onItemClick(item) {
      this.$router.push({
        name: "item",
        params: { id: item.item_id },
      });
    },

    save() {
      this.axios
        .put("bundlegroups/" + this.item.id, this.item)
        .then((res) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text:
              this.$t("GLOBAL-MESSAGE-ERROR") +
              ": " +
              err.response.data.message,
            type: "error",
          });
        });
    },

    initialize() {
      this.axios.get(`bundlegroups/${this.$route.params.id}`).then((res) => {
        this.item = res.data;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
